import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { GetCountry } from "../../../../redux/master/action";
import { disabledStyle } from "../../../Common/ClickDisable";
import { Tooltip } from "react-tooltip";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import ReactSelect from "react-select";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import { getDeliveryType } from "../../../../redux/categary/action";

// Import the new TimePickerInput component
import TimePickerInput from "../../../Common/TimePickerInput";
import TimePickerRSuite from "../../../Common/TimePickerRSuite";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const bxpDatatomap = [
  { title: (<>Buy & Sell with Auction (BSA) type <AsteriskLabel /></>), name: "auction_type", placeholder: "Buy & Sell with Auction (BSA) type" },
  { title: (<>Date of Buy & Sell with Auction (BSA) <AsteriskLabel /></>), name: "start_date", placeholder: "Date of Buy & Sell with Auction (BSA) " },
  { title: (<>Buy & Sell with Auction (BSA) duration <AsteriskLabel /></>), name: "duration_type", placeholder: "Buy & Sell with Auction (BSA) duration" },
  { title: (<>No of day <AsteriskLabel /></>), name: "duration", placeholder: "No of day" },
  { title: (<>Delivery type <AsteriskLabel /></>), name: "delivery_type_id", placeholder: "Delivery type" },
];

const duretiontypeoptions = [
  { value: 2, label: "Days" },
  { value: 3, label: "Weeks" },
  { value: 4, label: "Months" },
];

const actiontypeoptions = [
  { value: 1, label: "Sealed" },
  { value: 2, label: "Incrimental" },
];

const Today = new Date();
const formattedDate = Today.toISOString().split('T')[0];

const WorkSamples = ({ bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);
  const deliverytypelist = useSelector(({ categary: { deliverytypelist } }) => deliverytypelist);

  useEffect(() => {
    dispatch(GetCountry());
    dispatch(getDeliveryType());
  }, [dispatch]);

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FirstTimeUsers.module.scss");
  }, []);

  const initialValues = {
    auction_type: bxpData?.auction_type || "1",
    start_date: bxpData?.start_date || "",
    duration_type: bxpData?.duration_type || "1",
    duration: bxpData?.duration || "",
    delivery_type_id: bxpData?.delivery_type_id || "27",
    start_time: bxpData?.start_time || ''
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0); // remove time portion
  const maxDate = new Date("2050-12-31");

  // Updated validation schema
  const validationSchema = Yup.object().shape({
    auction_type: Yup.string().required("Auction type is required"),
    start_date: Yup.date()
      .required("Date of Auction is required")
      .nullable()
      .min(today, "Past dates are not allowed")
      .max(maxDate, "Date cannot be later than the year 2050"),

    duration_type: Yup.string().required("Auction duration type is required"),
    duration: Yup.number()
      .required("Duration is required")
      .integer("Duration must be an integer")
      .when("duration_type", {
        is: (val) => val == "1",
        then: (schema) => schema.positive("Hour must be a positive number"),
        otherwise: (schema) =>
          schema.when("duration_type", {
            is: (val) => val == "2",
            then: (schema) => schema.positive("Day must be a positive number"),
            otherwise: (schema) =>
              schema.when("duration_type", {
                is: (val) => val == "3",
                then: (schema) => schema.positive("Week must be a positive number"),
                otherwise: (schema) =>
                  schema.when("duration_type", {
                    is: (val) => val == "4",
                    then: (schema) => schema.positive("Month must be a positive number"),
                    otherwise: (schema) => schema.positive("Duration must be a positive number"),
                  }),
              }),
          }),
      }),
    delivery_type_id: Yup.string().required("Delivery type is required"),
    start_time: Yup.string()
      .required("Start time is required")
      .test(
        "not-past-time-utc",
        "Start time cannot be in the past (UTC)",
        function (value) {
          const { start_date } = this.parent;
          if (!value || !start_date) return true;

          const dateObj = new Date(start_date);
          const startDay = new Date(dateObj);
          startDay.setHours(0, 0, 0, 0);

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          if (startDay > today) {
            return true;
          }

          const [hours, minutes] = value.split(":").map(Number);

          // Current UTC hours & minutes
          const now = new Date();
          const currentUTCHours = now.getUTCHours();
          const currentUTCMinutes = now.getUTCMinutes();

          // Selected UTC hours & minutes
          const localDateTime = new Date(
            dateObj.getFullYear(),
            dateObj.getMonth(),
            dateObj.getDate(),
            hours,
            minutes,
            0
          );
          const selectedUTC = new Date(localDateTime.getTime() - localDateTime.getTimezoneOffset() * 60000);
          const selectedUTCHours = selectedUTC.getUTCHours();
          const selectedUTCMinutes = selectedUTC.getUTCMinutes();

          // Compare hours & minutes only
          if (selectedUTCHours > currentUTCHours) return true;
          if (selectedUTCHours === currentUTCHours && selectedUTCMinutes >= currentUTCMinutes) return true;
          return false;
        }
      )

  });


  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      updatedData = { ...updatedData };
      setbxpData(updatedData);
      setActiveTab("PricingTerms");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentDate = () => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  };

  const getCurrentTime = () => {
    const date = new Date();
    return date.toISOString().split('T')[1].substring(0, 5);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            {bxpDatatomap.map((prop, key) => {
              if (prop.name === "start_date") {
                return (
                  <React.Fragment key={key}>
                    <button
                      type="button"
                      onClick={() => {
                        formik.setFieldValue('start_date', getCurrentDate());
                        formik.setFieldValue('start_time', getCurrentTime());
                      }}
                    >
                      Add Current Days Time
                    </button>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="form-group col-md-6">
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          type='date'
                          min={formattedDate}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Start time (in UTC) <AsteriskLabel /></label>
                        <TimePickerRSuite
                          formik={formik}
                          name={`start_time`}
                          label=""
                          selectedDate={formik?.values?.start_date}
                        />
                        {/* <Field
                          name="start_time"
                          component={TimePickerInput}
                          placeholder="Start Time"
                        /> */}
                        <br></br>
                        <ErrorMessage name="start_time" component="div" className="error" />
                      </div>
                    </div>
                  </React.Fragment>
                );
              }
              if (prop.name === "auction_type") {
                return (
                  <div className="form-group" key={key}>
                    <label>{prop?.title} &nbsp;
                      <img
                        data-tooltip-id="my-tooltip-1"
                        src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                        alt=""
                      />
                    </label>

                    <ReactSelect
                      options={actiontypeoptions}
                      placeholder="Select auction type"
                      value={actiontypeoptions.find((val) => val.value == formik.values[prop.name])}
                      onChange={(selectedOption) => formik.setFieldValue(prop?.name, selectedOption?.value)}
                    />
                    <ErrorMessage name={prop?.name} component="div" className="error" />
                  </div>
                );
              }
              if (prop.name === "duration") {
                return (
                  <NumberInputBox
                    title={`Duration in ${formik.values.duration_type == 1
                      ? "hour"
                      : formik.values.duration_type == 2
                        ? "day"
                        : formik.values.duration_type == 3
                          ? "weeks"
                          : formik.values.duration_type == 4
                            ? "months"
                            : ""
                      }`}
                    name={prop.name}
                    placeholder={`Duration in ${formik.values.duration_type == 1
                      ? "hour"
                      : formik.values.duration_type == 2
                        ? "day"
                        : formik.values.duration_type == 3
                          ? "weeks"
                          : formik.values.duration_type == 4
                            ? "months"
                            : ""
                      }`}
                    key={key}
                  />
                );
              }

              if (prop.name === "duration_type") {
                return (
                  <div key={key} className="form-group">
                    <label>{prop.title}</label>
                    <div className="label-check">
                      <label className="checkbox-container">
                        <Field type="radio" name={prop.name} value="1" checked={formik.values[prop.name] == 1} />
                        <span className="checkmark">Hour</span>
                      </label>
                      <label className="checkbox-container">
                        <Field type="radio" name={prop.name} value="2" checked={formik.values[prop.name] == 2} />
                        <span className="checkmark">Days</span>
                      </label>
                      <label className="checkbox-container">
                        <Field type="radio" name={prop.name} value="3" checked={formik.values[prop.name] == 3} />
                        <span className="checkmark">Week</span>
                      </label>
                      <label className="checkbox-container">
                        <Field type="radio" name={prop.name} value="4" checked={formik.values[prop.name] == 4} />
                        <span className="checkmark">Month</span>
                      </label>
                    </div>
                    <ErrorMessage name={prop.name} component="div" className="error" />
                  </div>
                );
              }
              if (prop.name === "delivery_type_id") {
                return (
                  <div key={key} className="form-group">
                    <label>{prop.title}</label>
                    <div className="label-check">
                      {Array.isArray(deliverytypelist) && deliverytypelist.map(deliveryType => (
                        <label key={deliveryType.id} className="checkbox-container">
                          <Field
                            type="radio"
                            name={prop.name}
                            value={deliveryType.id}
                            checked={formik.values[prop.name] == deliveryType.id}
                            onChange={() => {
                              formik?.setFieldValue('delivery_type_id', deliveryType.id);
                              formik?.setFieldValue('delivery_type_title', deliveryType.title);
                            }}
                          />
                          <span className="checkmark">{deliveryType.title}</span>
                        </label>
                      ))}
                    </div>
                    <ErrorMessage name={prop.name} component="div" className="error" />
                  </div>
                );
              }

              return (
                <FieldInput
                  title={prop.title}
                  name={prop.name}
                  placeholder={prop.placeholder}
                  key={key}
                />
              );
            })}
            <div className="button-container" style={{ marginTop: 20 }}>
              <div
                style={loading ? disabledStyle : {}}
                type="button"
                className="prev-button btn w-100"
                onClick={() => setActiveTab("BXPDetails")}
              >
                Back
              </div>
              <div
                className="next-button btn w-100"
                type="submit"
                onClick={formik.handleSubmit}
              >
                {loading ? <LoginLoaderButton /> : "Next"}
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content="Urxprt will Interpret the information given by the customer and will operate the machine on their behalf."
      />
    </div>
  );
};

export default WorkSamples;
